module.exports = __webpack_public_path__ + "static/media/PMI_Certfication.5e788e3e.png";